import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-reset-control-button',
  templateUrl: './reset-control-button.component.html',
  styleUrls: ['./reset-control-button.component.scss']
})
export class ResetControlButtonComponent implements OnInit {
  @Input() control: UntypedFormControl;

  constructor() { }

  ngOnInit() {
  }

  reset() {
    this.control.reset();
  }
}
